import {
  Box,
  ThemeLoader,
} from "../../../../components/styled/Elements";
import useCabinetOptions from "../../../../hooks/useCabinetOptions";
import styled from "styled-components";
import MyDepartmentOptions from "./MyDepartmentOptions";
import OtherDepartmentOptions from "./OtherDepartmentOptions";
import MySelfDepartmentOptions from "./MySelfDepartmentOptions";
import BaseCabinetOption from "./BaseCabinetOption";

const AccessSettings = ({showBaseCabinetOption = false}) => {
  const { isLoading } = useCabinetOptions();

  if (isLoading) return <ThemeLoader />;

  return (
    <Box className="optionsWrapper">
      {showBaseCabinetOption && <BaseCabinetOption />}
      <MyDepartmentOptions />
      <OtherDepartmentOptions />
      <MySelfDepartmentOptions />
    </Box>
  );
};

export default AccessSettings;

export const FormRadioWrapper = styled.label`
  display: flex;
  align-items: ${({ subLabel }) => !subLabel && "center"};
  gap: 15px;
  width: 100%;
  padding: 11px 15px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: var(--white);

  .radio-input {
    appearance: none;
    min-width: 25px;
    max-width: 25px;
    height: 25px;
    border: 2px solid var(--border);
    background-color: var(--bgSecondary);
    border-radius: 50%;
    position: relative;

    &:checked {
      border: 7px solid var(--themeColor2);
    }

    &:checked::after {
      content: "";
      width: 9px;
      height: 9px;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  /* ✅ THIS FIXES YOUR LABEL HIGHLIGHT */
  &:has(.radio-input:checked) .radio-label {
    color: var(--themeColor2);
    font-weight: 900;
  }

  @media (max-width: 530px) {
    padding: 5px;
  }
`;
